import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToolbarMenuContent } from './toolbar-menu-content';
import { ToolBarMenuItem } from './toolbar-menu-item';
import { Observable } from 'rxjs';

@Component({
    selector: 'toolbar-menu',
    template: require('./toolbar-menu.component.html'),
    styles: [require('./toolbar-menu.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ToolbarMenuComponent implements OnInit {

    @Input()
    public userName: string;

    @Input()
    public emulatedUserFullName: string;

    public menuItems: Observable<ToolBarMenuItem[]>;

    public logoutText = '';
    public logoutAction: () => void = null;

    constructor(private menuItemsService: ToolbarMenuContent) { }

    public ngOnInit(): void {
        this.menuItems = this.menuItemsService.getMenuItems();
        this.menuItemsService.getMenuItem('Logout').subscribe(menuItem => {
            this.logoutText = menuItem.itemText;
            this.logoutAction = menuItem.action;
        });
    }
}